var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"app "}},[(_vm.$route.name !== 'login' && _vm.$route.name !== 'regist')?_c('div',{staticClass:"app"},[_c('HomeHeader'),_c('router-view'),_c('HomeFooter')],1):_c('router-view')],1),_c('el-backtop',{attrs:{"visibility-height":200,"duration":300}},[_c('div',[_c('i',{staticClass:"el-icon-caret-top"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }